theme.alinga = {};

theme.alinga.footerMenuAccordian = () => {
  if(window.innerWidth <= 749){
    const accordionBtns = document.querySelectorAll(".mobileAccordion .footer__block__title");

    accordionBtns.forEach((accordion) => {
      accordion.onclick = function () {
        this.classList.toggle("active");

        let content = this.nextElementSibling;
        console.log(content);

        if (content.style.maxHeight) {
          content.style.maxHeight = null;
          console.log(content.scrollHeight);
        } else {
          content.style.maxHeight = content.scrollHeight + "px";
          console.log(content.style.maxHeight);
        }
      };
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  theme.alinga.footerMenuAccordian();
})